module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/19QbcO3/images/cover.jpg?1737031378419",
      "alt": "This image is the cover for the book Dutch Oven Cooking"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Dutch Oven Cooking\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Discover the endless possibilities of this traditional cookware with recipes, tips and ")]), _c('b', [_vm._v("techniques from a Dutch Oven Society World Champion.")])]), _c('p', [_vm._v("In this comprehensive cookbook, Dutch oven master Terry Lewis shares his expert knowledge along with an array of mouthwatering recipes that show off the traditional Dutch Oven’s incredible range and versatility. Designed to inspire home cooks of all levels, "), _c('i', [_vm._v("Dutch Oven Cooking")]), _vm._v(" is the ideal guide to making Dutch oven breads, main courses, desserts, and more.")]), _c('p', [_vm._v("Beginners will find success with simply delicious recipes like Dutch Oven Stew, Chicken and Rice, and Easy Cobbler. The intermediate level cooks will enjoy putting their skills to the test with satisfying dishes like Chicken Cordon Bleu, Honey Rolls, and Oatmeal Chocolate Cake. Folks looking to compete with the best can try their hand at Maple BBQ Baby Back Ribs with Buttered Almond Rice, Sourdough Herb Rolls, and Carmel Pumpkin Cheesecake.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Terry Lewis\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Terry Lewis, with the help of his daughter Tori, is a two-time winner of the World Championship Cook-offs held by the International Dutch Oven Society. He has been cooking and competing in Dutch oven events for over twenty years and occasionally uses his expertise to judge cooking competitions. Terry lives in Tabiona, Utah.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0